module.exports = __webpack_public_path__ + "img/train_banner_mobile.f66d4ca7.png";